




















































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  getAllMenuTreeList,
  getuserTableData,
  postuserTableData,
  putUserTableData,
  postMenuData,
  putMenuData,
  delMenuData,
  delUserTableData,
  getMenuDataById
} from "../../../api/menuManage";
import { Tree, Progress } from "element-ui";
import { ruleNormal, rulePattern, hasPermission } from "../../../utils/common";
Vue.use(hasPermission);

interface sourceForm {
  resourceCode: string | undefined;
  resourceType: string | undefined;
  resourceName: string | undefined;
  resourceUrl: string | undefined;
  resourceMethod: string | undefined;
  resourceOrder: number | undefined; // 序号要前端特别校验
  resourceDescription: string | undefined;
  isEnable: boolean | undefined;
  menuId: string | undefined;
  resourceId: string | undefined; // 修改项的资源id
}
// 菜单弹框新增显示的基本信息
interface MenuDesFormInfo {
  menuName: string | undefined;
  menuCode: string | undefined;
  menuType: string | undefined;
  menuHref: string | undefined;
  resourceMethod: string | undefined;
  menuOrder: number | undefined; // 序号要前端特别校验
  isEnable: string | boolean | undefined;
  menuDescription: string | undefined;
  menuIcon: string | undefined;
  menuParentId: number | undefined;
  id: string | undefined; // 修改菜单用到的id，我也不确定哎
}
interface menuDecForm {
  menuName: string | undefined;
  menuCode: string | undefined;
  menuType: string | undefined;
  menuHref: string | undefined;
  menuOrder: number | undefined;
  isEnable: boolean;
  menuIcon: string | undefined;
  menuDescription: string | undefined;
  menuParentId: string | undefined;
  menuId: number | undefined; // 修改菜单用到的id，我也不确定哎
}
interface userTableData {
  // checked: Array<string> | undefined;
  resourceCode: string | undefined;
  resourceType: string | undefined;
  resourceName: string | undefined;
  resourceUrl: string | undefined;
  resourceMethod: string | undefined;
  resourceOrder: number | undefined; // 序号要前端特别校验
  resourceDescription: string | undefined;
  isEnable: string | boolean | undefined;
  menuParentId: number | undefined;
  id: string | undefined; // 修改菜单用到的id，我也不确定哎
  menuId: any | undefined;
  resourceId: any | undefined; // 修改项的资源id
}
interface delObj {
  childList: Array<object> | undefined;
  href: string | undefined;
  id: string | undefined;
  isChecked: boolean | undefined;
  name: string | undefined;
  parentId: string | undefined;
}

// 菜单表格查询
interface searchFormInfo {
  current: number | undefined;
  isEnable: string | undefined;
  resourceCodeOrName: string | undefined;
  menuId: string | undefined;
  size: number | undefined;
}

@Component({
  name: "menuManage",
  filters: {
    filterIsEnable(v) {
      let map = {
        true: "可用",
        TRUE: "可用",
        FALSE: "不可用",
        false: "不可用"
      };
      return map[v];
    }
  }
})
export default class menu extends Vue {
  // 树形组件所需数据
  private MenuTreeData: Array<Object> = [];
  private chkedArr: Array<Object> = [];
  private defaultProps: Object = {
    children: "childList",
    label: "name"
  };
  private menuTreeLoading:boolean = false //tree loading
  private menuidid: string = ""; // 全局的菜单id
  private parentidid: string = ""; // 全局的父id，
  //  菜单的变量
  private iconindex: number = 0;
  private delObj: delObj = {
    childList: [],
    href: "",
    id: "",
    isChecked: false,
    name: "",
    parentId: ""
  };
  // 右键点击的对象的复制
  private isNotRootMenu: boolean = true; //默认为true，代表右键不是点击最顶层的tree菜单
  // private iconclname :any;
  private iconclname: string = "el-icon-s-grid showicon";
  // 提示的公共弹框
  private tkDialogVisible: boolean = false;
  private tkTitle: string = "";
  private tkInfomation: string = "";
  //chaolaide
  private form: object = {};
  private userTableData: Array<object> = [];
  // 菜单弹框新增显示的基本信息
  private MenuDesForm: any = {
    menuName: "",
    menuCode: "",
    menuType: "",
    menuHref: "",
    menuOrder: undefined,
    isEnable: true,
    menuIcon: "",
    menuDescription: "",
    menuParentId: "",
    menuId: 0 // 修改菜单用到的id，我也不确定哎
  };
  // 资源新增显示的数据
  private sourceForm: sourceForm = {
    resourceCode: "",
    resourceType: "",
    resourceName: "",
    resourceUrl: "",
    resourceMethod: "",
    resourceOrder: 0,
    resourceDescription: "",
    isEnable: true,
    menuId: "101",
    resourceId: "12" // 修改项的资源id
  };
  // 用户资源表格的规则
  private userTableRules: object = {
    resourceCode: [
      { required: true, message: "请输入资源编码", trigger: "blur" },
      {
        message: "仅支持英文和数字",
        pattern: /^[^\u4e00-\u9fa5]+$/,
        trigger: "blur"
      }
    ],
    resourceType: [
      { required: true, message: "请输入资源类型", trigger: "blur" }
    ],
    resourceName: [
      { required: true, message: "请输入资源名称", trigger: "blur" }
    ],
    resourceUrl: [
      { required: true, message: "请输入资源路径", trigger: "blur" },
      {
        message: "仅支持英文和数字",
        pattern: /^[^\u4e00-\u9fa5]+$/,
        trigger: "blur"
      }
    ],
    resourceMethod: [
      { required: true, message: "请输入资源方法", trigger: "blur" }
    ],
    resourceOrder: [rulePattern(/^(|[0-9]+)$/, "请输入整数数字")],
    menuisEnable: [
      { required: false, message: "请选择资源是否禁用", trigger: "change" }
    ],
    resourceDescription: [
      { required: true, message: "请选择资源描述", trigger: "blur" }
    ]
  };
  // 资源方法的下拉数据
  private resMethodOptions: Array<object> = [
    {
      value: "get",
      label: "get"
    },
    {
      value: "post",
      label: "post"
    },
    {
      value: "put",
      label: "put"
    },
    {
      value: "delete",
      label: "delete"
    }
  ];

  private filterText: string = "";
  private val: string = "";
  private tbTypeFlag: boolean = false; //tableTypeFlag
  private mnTypeFlag: boolean = false; // menuTypeFlag

  private userMenuFormVisible: boolean = false; // tree右键 增加， 修改 弹框 显示
  private menuVisible: boolean = false; //
  private rightclickData: object = {};
  private tableLoading: boolean = false;
  private total: number = 0; // 总条数
  private size: number = 10; // 默认每页显示数量
  private current: number = 1; // 分页栏当前页码
  // 菜单选中的数组 --- 应该是左侧table展示，复选框选中的ids
  private ids: Array<string> = [];
  private tempArr: Array<string> = [];

  // 用户菜单的规则
  private userMenuRules: object = {
    menuName: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
    menuCode: [
      { required: true, message: "请输入菜单编码", trigger: "blur" },
      {
        message: "仅支持英文和数字",
        pattern: /^[^\u4e00-\u9fa5]+$/,
        trigger: "blur"
      }
    ],
    menuType: [{ required: true, message: "请选择菜单类型", trigger: "blur" }],
    menuHref: [
      // 路径不能为中文 /^[^\u4e00-\u9fa5]+$/
      { required: true, message: "请输入菜单路径", trigger: "blur" },
      {
        message: "仅支持英文和数字",
        pattern: /^[^\u4e00-\u9fa5]+$/,
        trigger: "blur"
      }
    ],
    menuOrder: [rulePattern(/^(|[0-9]+)$/, "请输入整数")],
    isEnable: [
      { required: true, message: "请选择资源是否可用", trigger: "change" }
    ],
    menuDescription: [
      // { required: true, message: "请输入菜单描述", trigger: "blur" }
    ]
  };
  private async getAllMenuData() {
    try {
      let res = await getAllMenuTreeList();
      this.MenuTreeData = res.data;
      this.menuidid = res.data[0].id; // 默认第一个数据
    } catch (error) {
      this["$message"].error(error);
    }
  }
  private async menuInit() {
    try {
      let res = await getAllMenuTreeList();
      this.MenuTreeData = res.data;
      this.menuidid = res.data[0].id; // 默认第一个数据
      this.resParentName = res.data[0].name; // 默认增加的title为第一个数据的name
      this.getuserTableList();
    } catch (error) {
      this[`$message`]({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  private async getuserTableList() {
    try {
      if (!this.menuidid) {
        this.$message.warning("请先选择左边菜单树");
        return false;
      }
      this.searchForm.menuId = this.menuidid;
      let res = await getuserTableData(this.searchForm);
      this.userTableData = res.data.records;
      this.total = res.data.total;
    } catch (error) {
      // this["$message"].error(error); // 可以只是捕获，但是不显示后台返回的信息
    }
  }
  // 弹框提示的公共
  private async tktishi(title, infomation) {
    this.tkDialogVisible = true;
    this.tkTitle = title;
    this.tkInfomation = infomation;
  }

  mounted() {
    //初始化显示系统菜单数据
    this.current = 1;
    this.size = 10;
    this.menuInit(); // 为了避免出问题，所以才单独写的
  }

  public $refs!: {
    validate: HTMLFormElement;
    tree: HTMLFormElement;
  };
  // 节点筛选
  @Watch("filterText", { deep: true })
  getfilterText(val, MenuTreeData) {
    this.$refs.tree.filter(val);
  }

  private filterNode(value, MenuTreeData) {
    if (!value) return true;
    return MenuTreeData.name.indexOf(value) !== -1;
  }

  private resParentName: string = ""; // 用于右侧资源增加修改显示父级名称的
  private async handleNodeClick(data) {
    this.menuTreeLoading = true
    this.menuidid = data.id;
    this.resParentName = data.name;
    this.parentidid = data.id;
    this.getuserTableList();
    this.menuVisible = false; // 当点击树形组件的时候，隐藏右键菜单
    this.menuTreeLoading = false
  }

  // 右键增加修改要用到的根据父级id所获取的父级name，这个id用
  private idForParentName: string = "";
  private parentNameForShow: string = "";
  private async rightClick(event, object, value, element) {
    this.menuVisible = true;
    let rightClickMenu: any = document.querySelector("#rightClickMenuBox");
    // /* 菜单定位基于鼠标点击位置 */
    rightClickMenu.style.zIndex = "9";
    rightClickMenu.style.left = event.clientX - event.offsetX + 60 + "px";
    rightClickMenu.style.top = event.clientY - event.offsetY + 10 + "px";

    this.idForParentName = object.parentId; // name专用id
    // this.MenuDesForm.menuParentId = object.id; //赋值给parentId
    this.MenuDesForm.menuId = object.id;
    this.parentidid = object.id;

    object.parentId == "-1"
      ? (this.isNotRootMenu = false)
      : (this.isNotRootMenu = true);
    this.delObj = object;
  }

  // 右键菜单中的增删改事件
  private async addMenuList() {
    this.userMenuFormVisible = true;
    this.mnTypeFlag = false;
    this.menuVisible = false; //隐藏右键菜单
    // this.MenuDesForm ={};
    this.userMenuInit();
    this.MenuDesForm.isEnable = true;
    this.MenuDesForm.menuParentId = this.parentidid; //赋值给parentId

    let res = await getMenuDataById(this.idForParentName);
    this.parentNameForShow = res.data.menuName;
  }

  // 增加 提交菜单  选项 NO_DEADLINE
  private async handleAddMenuForm() {
    let flag = false;
    this.$refs[`userMenuRules`].validate(valid => {
      valid && (flag = true);
    });
    if (!flag) return;
    try {
      if (this.mnTypeFlag) {
        // 修改
        await putMenuData(this.MenuDesForm);
      } else {
        this.MenuDesForm.menuParentId = this.parentidid;
        await postMenuData(this.MenuDesForm);
      }
      this.$message({
        type: "success",
        message: this.mnTypeFlag ? "修改成功" : "新增成功"
      });
      this.userMenuInit(); // 清空菜单添加表单
      this.userMenuFormVisible = false;
      this.getAllMenuData(); // 重新加载
    } catch (error) {
      this.$message.error(error);
    }
  }

  // 修改菜单
  private async updateMenuList() {
    this.mnTypeFlag = true;
    this.userMenuFormVisible = true;
    let id = this.delObj.id; // 测试时候写的
    let res1 = await getMenuDataById(id);
    this.MenuDesForm = res1.data;
    this.iconclname = this.MenuDesForm.menuIcon;

    let res = await getMenuDataById(this.idForParentName);
    this.parentNameForShow = res.data.menuName;
  }

  // 菜单的删除
  private async delMenuList() {
    let confirm: boolean = false;
    !this.delObj.childList
      ? await this.$confirm("此操作将永久删除该菜单, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error"
        })
          .then(() => {
            confirm = true;
          })
          .catch(() => {
            confirm = false;
          })
      : await this.$confirm(
          "此操作将永久删除该菜单及该菜单下所有子菜单, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "error"
          }
        )
          .then(() => {
            confirm = true;
          })
          .catch(() => {
            confirm = false;
          });
    this.menuVisible = false;
    if (!confirm) return;
    try {
      await delMenuData(this.delObj.id);
      this.$message.success("已成功删除");
      // 再重新加载
      this.getAllMenuData();
    } catch (error) {
      this.$message({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  // icon的选择
  private async selectIcon(index) {
    let iconindex = index;
    this.iconclname = this.iconData[iconindex].clname;
    this.MenuDesForm.menuIcon = this.iconData[iconindex].clname;
    this.iconDialogVisible = false;
  }

  // 页面的增删改事件
  private addSourceialogFormVisible: boolean = false;
  private async addSourceList() {
    if (!this.menuidid) {
      this.tktishi("提示", "请先选择菜单");
      return false;
    } else {
      this.dataInit();
      this.addSourceialogFormVisible = true;
      this.tbTypeFlag = false;
      this.sourceForm.isEnable = true;
    }
  }

  // 资源编辑 isEnable
  private async updateSourceList(obj) {
    this.tbTypeFlag = true;
    this.addSourceialogFormVisible = true;
    this.sourceForm = obj;
  }

  // 判断表格当前行是否选中
  //  private tableSelectionId: Array<string> = []; //表格选中的数据id集合
  private handleSelectionChange(selection) {
    this.ids = selection.reduce((arr, curVal) => {
      arr.push(curVal.resourceId);
      return arr;
    }, []);
  }

  // 资源删除
  private async delSourceList() {
    if (this.ids.length === 0) {
      this.tktishi("温馨提示", "请先选择要删除的内容！");
      return false;
    } else {
      let confirm: boolean = false;
      await this.$confirm("此操作将永久删除该资源, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          confirm = true;
        })
        .catch(() => {
          confirm = false;
        });
      if (!confirm) return;
      try {
        await delUserTableData(this.ids);
        this.$message.success("已成功删除");
        this.ids = [];
        this.current =
          Math.ceil((this.total - 1) / this.size) < this.current
            ? --this.current
            : this.current;
        // 再重新加载
        this.getuserTableList();
      } catch (error) {
        this.$message({
          type: "error",
          message: error!.mesg ? error!.mesg : error
        });
      }
    }
  }

  // 清空资源表单
  private dataInit() {
    this.sourceForm = {
      resourceCode: undefined,
      resourceType: undefined,
      resourceName: undefined,
      resourceUrl: undefined,
      resourceMethod: undefined,
      resourceOrder: undefined, // 序号要前端特别校验
      resourceDescription: undefined,
      isEnable: undefined,
      menuId: undefined,
      resourceId: undefined
    };
  }

  private handleMenuClose() {
    this.userMenuInit();
    this.userMenuFormVisible = false;
  }

  // 清空菜单表单
  private userMenuInit() {
    this.MenuDesForm = {
      menuName: undefined,
      menuCode: undefined,
      menuType: undefined,
      menuHref: undefined,
      // resourceMethod: undefined,
      menuOrder: undefined,
      isEnable: true,
      menuDescription: undefined,
      menuParentId: undefined,
      id: undefined
    };
    this.iconclname = "el-icon-s-grid showicon";
  }

  // 增加提交事件
  private async handleAddSource() {
    let flag = false;
    this.$refs[`sourceForm`].validate(valid => {
      valid && (flag = true);
    });
    if (!flag) return;

    try {
      this.sourceForm.menuId = this.menuidid;
      this.tbTypeFlag
        ? await putUserTableData(this.sourceForm)
        : await postuserTableData(this.sourceForm);
      this.$message({
        type: "success",
        message: this.tbTypeFlag ? "修改成功" : "新增成功"
      });
      this.getuserTableList();
      this.$refs[`sourceForm`].clearValidate();
      this.addSourceialogFormVisible = false;
      this.dataInit();
    } catch (error) {
      this.$message.error(error || (this.tbTypeFlag ? "修改失败" : "新增失败"));
    }
  }
  // 获取 userTableData 展示数据

  private handleMenuisEnable(val) {}
  private handleSourceisEnable(val) {}
  // 修改信息的icon的对话框
  private iconDialogVisible: boolean = false;
  private iconData: Array<any> = [
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-delete-solid",
      labelName: ""
    },
    {
      clname: "el-icon-delete",
      labelName: ""
    },
    {
      clname: "el-icon-s-tools",
      labelName: ""
    },
    {
      clname: "el-icon-setting",
      labelName: ""
    },
    {
      clname: "el-icon-user-solid",
      labelName: ""
    },
    {
      clname: "el-icon-phone",
      labelName: ""
    },
    {
      clname: "el-icon-user",
      labelName: ""
    },
    {
      clname: "el-icon-phone-outline",
      labelName: ""
    },
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    },
    {
      clname: "el-icon-platform-eleme",
      labelName: ""
    }
  ];
  private showIconForm() {
    this.iconDialogVisible = true;
  }

  // 分页
  private handleSizeChange(val) {
    this.size = val;
    this.searchForm.current = val;
    this.getuserTableList();
  }
  private handleCurrentChange(val) {
    this.current = val;
    this.searchForm.current = val;
    this.getuserTableList();
  }

  /*-------------菜单查询部分开始----------- */

  private searchTableLoading: boolean = false;
  private searchForm: searchFormInfo = {
    current: this.current,
    isEnable: undefined,
    resourceCodeOrName: undefined,
    menuId: this.menuidid,
    size: this.size
  };

  //搜索重置
  private handleResetSearch() {
    this.searchForm = {
      current: 1,
      isEnable: undefined,
      resourceCodeOrName: undefined,
      menuId: this.menuidid,
      size: 10
    };
    this.getuserTableList();
  }
  /*-------------菜单查询部分结束----------- */

  // 自定义菜单显示
  private async rightMouseOver(ev, obj) {}
  //改写tree组件开始
  private async treeAppend(data) {
    this.userMenuFormVisible = true;
    this.mnTypeFlag = false;
    this.userMenuInit();
    this.MenuDesForm.isEnable = true;
    this.MenuDesForm.menuParentId = data.id; //赋值给parentId
    this.parentidid = data.id;
    this.parentNameForShow = data.name;
  }
  private async treeEdit(data) {
    this.mnTypeFlag = true;
    this.userMenuFormVisible = true;
    let res1 = await getMenuDataById(data.id);
    this.MenuDesForm = res1.data;
    // 有时候后台 menuIcon 返回为空，图标那一栏，就不会显示，这里给一个默认字段
    // 或者在上面应用的地方给默认值，都可以
    this.iconclname = this.MenuDesForm.menuIcon || "el-icon-s-grid showicon";

    let res = await getMenuDataById(data.parentId);
    if (res.data.menuName == undefined) {
      this.parentNameForShow = "";
    } else {
      this.parentNameForShow = res.data.menuName;
    }
  }
  private async treeDel(data) {
    let confirm: boolean = false;
    !data.childList
      ? await this.$confirm("此操作将永久删除该菜单, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "error"
        })
          .then(() => {
            confirm = true;
          })
          .catch(() => {
            confirm = false;
          })
      : await this.$confirm(
          "此操作将永久删除该菜单及该菜单下所有子菜单, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "error"
          }
        )
          .then(() => {
            confirm = true;
          })
          .catch(() => {
            confirm = false;
          });
    if (!confirm) return;
    try {
      await delMenuData(data.id);
      this.$message.success("已成功删除");
      // 再重新加载
      this.getAllMenuData();
    } catch (error) {
      this.$message({
        type: "error",
        message: error!.mesg ? error!.mesg : error
      });
    }
  }

  private mouseleave(data, $event) {
    this.$set(data, "dis", false);
  }
  private mouseover(data: any) {
    this.$set(data, "dis", true);
  }
  //改写tree组件结束
}
